'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled, { css } from 'styled-components';

var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    line-height: 1.2;\n"], ["\n    width: 100%;\n    line-height: 1.2;\n"])));
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n"], ["\n    width: 100%;\n"])));
var ListJob = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var gridColumn = _a.gridColumn;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            display: flex;\n            flex-wrap: wrap;\n            gap: 8px;\n\n            > div {\n                width: calc((100% - 8px * ", ") / ", ");\n            }\n        "], ["\n            display: flex;\n            flex-wrap: wrap;\n            gap: 8px;\n\n            > div {\n                width: calc((100% - 8px * ", ") / ", ");\n            }\n        "])), (gridColumn || 1) - 1, gridColumn || 1);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

export { Container, ListJob, Wrapper };
//# sourceMappingURL=JobCardMiniList.css.js.map
